var _path, _path2, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAudioEducation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.625 38.75C14 39 13.625 39.625 13.75 40.25C14 40.875 14.625 41.25 15.25 41.125C23.625 38.75 29.375 41.125 30.25 42C30.5 42.25 30.875 42.375 31.125 42.375C31.375 42.375 31.75 42.25 32 42C32.5 41.5 32.5 40.75 32 40.25C30.5 38.75 23.875 36.125 14.625 38.75Z",
    fill: "url(#paint0_linear_247_1773)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.625 32.5C14 32.75 13.625 33.375 13.75 34C14 34.625 14.625 35 15.25 34.875C23.625 32.5 29.375 34.875 30.25 35.75C30.5 36 30.875 36.125 31.125 36.125C31.375 36.125 31.75 36 32 35.75C32.5 35.25 32.5 34.5 32 34C30.5 32.5 23.875 29.875 14.625 32.5Z",
    fill: "url(#paint1_linear_247_1773)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.625 26.25C14 26.5 13.625 27.125 13.75 27.75C14 28.375 14.625 28.75 15.25 28.625C23.625 26.25 29.375 28.625 30.25 29.5C30.5 29.75 30.875 29.875 31.125 29.875C31.375 29.875 31.75 29.75 32 29.5C32.5 29 32.5 28.25 32 27.75C30.5 26.25 23.875 23.625 14.625 26.25Z",
    fill: "url(#paint2_linear_247_1773)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.125 35.875C37.625 35.375 40.375 34 45 33.875C45.75 33.875 46.25 33.25 46.25 32.625C46.25 32 45.625 31.375 45 31.375C39.875 31.375 36.5 33 35.375 34C34.875 34.5 34.875 35.25 35.375 35.75C35.625 36 36 36.125 36.25 36.125C36.5 36.125 36.875 36.125 37.125 35.875Z",
    fill: "url(#paint3_linear_247_1773)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.25 30C36.625 30 36.875 29.8751 37.125 29.6251C38 28.7501 43.875 26.25 52.125 28.75C52.75 29 53.5 28.5 53.625 27.875C53.875 27.25 53.375 26.5001 52.75 26.3751C43.5 23.7501 36.875 26.375 35.25 28C34.75 28.5 34.75 29.25 35.25 29.75C35.625 29.875 35.875 30 36.25 30Z",
    fill: "url(#paint4_linear_247_1773)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4501 58.1791H71.9824V56.7114V50.1067C71.9824 42.9149 67.726 36.6037 61.7084 33.6683V14.1478C61.7084 13.5607 61.4149 13.1204 60.8278 12.8268C60.3875 12.5333 48.499 6.80923 32.2074 12.5333C29.272 11.5059 14.7417 7.24954 3.73386 12.8268C3.29354 13.1204 3 13.5607 3 14.1478V51.7212C3 52.1615 3.14677 52.6018 3.58708 52.8953C3.88063 53.1889 4.32094 53.3356 4.76125 53.1889C14.1546 51.1341 23.5479 51.8679 31.6204 55.2437C31.7671 55.2437 32.0607 55.3904 32.2074 55.3904H32.6478C32.7945 55.3904 33.0881 55.3904 33.2348 55.2437C33.9687 54.9501 34.7025 54.6566 35.4364 54.5098V56.7114V58.1791H33.9687C31.4736 58.1791 29.5656 60.0871 29.5656 62.5822C29.5656 65.0773 31.4736 66.9854 33.9687 66.9854H35.4364V68.4531C35.4364 69.3337 36.0235 69.9208 36.9041 69.9208H45.7104C48.2055 69.9208 50.1135 68.0127 50.1135 65.5176V59.6468C50.1135 57.1517 48.2055 55.2437 45.7104 55.2437H38.3718V53.4824C45.1233 51.7212 52.6086 51.5744 60.0939 53.1889C60.5342 53.3356 60.9746 53.1889 61.2681 52.8953C61.5616 52.6018 61.8552 52.1615 61.8552 51.7212V37.0441C66.2583 39.8327 69.1937 44.6762 69.1937 50.1067V55.2437H61.8552C59.3601 55.2437 57.4521 57.1517 57.4521 59.6468V65.5176C57.4521 68.0127 59.3601 69.9208 61.8552 69.9208H70.6614C71.5421 69.9208 72.1292 69.3337 72.1292 68.4531V66.9854H73.5969C76.092 66.9854 78 65.0773 78 62.5822C78 60.0871 75.9452 58.1791 73.4501 58.1791ZM33.8219 64.0499C32.9413 64.0499 32.3542 63.4628 32.3542 62.5822C32.3542 61.7016 32.9413 61.1145 33.8219 61.1145H35.2896V64.0499H33.8219ZM45.5636 58.1791C46.4442 58.1791 47.0313 58.7662 47.0313 59.6468V65.5176C47.0313 66.3983 46.4442 66.9854 45.5636 66.9854H38.225V65.5176V59.6468V58.1791H45.5636ZM32.3542 52.3082C27.0704 50.1067 21.3464 49.0793 15.3288 49.0793C12.2466 49.0793 9.01761 49.3728 5.93542 49.9599V15.0284C16.9432 10.185 31.7671 15.4687 31.9139 15.4687C32.2074 15.6155 32.6477 15.6155 32.9413 15.4687C45.8571 10.772 55.9843 14.001 58.9198 15.0284V32.4942C57.3053 32.0538 55.544 31.7603 53.7828 31.7603C43.5088 31.7603 35.2896 39.9795 35.2896 50.1067V51.2808C34.2622 51.5744 33.3816 51.8679 32.3542 52.3082ZM58.773 49.9599C51.728 48.639 44.683 48.7857 38.225 50.4002V50.1067C38.225 41.594 45.1233 34.6957 53.636 34.6957C55.3973 34.6957 57.1585 34.9893 58.773 35.5763V49.9599ZM60.2407 65.5176V59.6468C60.2407 58.7662 60.8278 58.1791 61.7084 58.1791H69.047V59.6468V65.5176V66.9854H61.7084C60.8278 66.9854 60.2407 66.3983 60.2407 65.5176ZM73.4501 64.0499H71.9824V61.1145H73.4501C74.3307 61.1145 74.9178 61.7016 74.9178 62.5822C74.9178 63.4628 74.3307 64.0499 73.4501 64.0499Z",
    fill: "url(#paint5_linear_247_1773)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_247_1773",
    x1: 23.125,
    y1: 15.3225,
    x2: 23.125,
    y2: 65.8475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38B582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#3BBFAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494,
    stopColor: "#3C97A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#3B89BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3861B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_247_1773",
    x1: 23.125,
    y1: 15.5125,
    x2: 23.125,
    y2: 66.0287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38B582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#3BBFAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494,
    stopColor: "#3C97A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#3B89BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3861B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_247_1773",
    x1: 23.125,
    y1: 15.3775,
    x2: 23.125,
    y2: 65.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38B582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#3BBFAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494,
    stopColor: "#3C97A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#3B89BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3861B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_247_1773",
    x1: 40.5975,
    y1: 15.2825,
    x2: 40.5975,
    y2: 65.9387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38B582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#3BBFAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494,
    stopColor: "#3C97A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#3B89BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3861B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_247_1773",
    x1: 44.375,
    y1: 15.4588,
    x2: 44.375,
    y2: 65.8563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38B582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#3BBFAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494,
    stopColor: "#3C97A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#3B89BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3861B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_247_1773",
    x1: 3.00037,
    y1: 39.9608,
    x2: 78,
    y2: 39.9608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6A69"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioEducation);
export default __webpack_public_path__ + "static/media/Audio Education.d6133e3243be010d1f012135891b9826.svg";
export { ForwardRef as ReactComponent };